import { primaryColors } from "../../assets/styles/helpers/colors.styles";

export const ratingStyles = {
  "&.MuiRating-root": {
    fontSize: "2rem",
  },
  ".MuiRating-icon": {
    color: primaryColors.white,
  },
};
